<div class="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-b from-[#0b1d3d] to-[#153b67] text-white text-center px-6">
  <div class="max-w-sm w-full flex flex-col items-center gap-8">
    <img ngOptimizedImage class="h-12" [src]="'/assets/image/prisma-logo-light.png'" alt="Prisma">

    <div class="flex flex-col gap-4">
      <h2 class="text-2xl font-semibold leading-snug">
        Ihre Finanzberatung der Zukunft.
      </h2>

      <p class="text-base leading-relaxed">
        Das smzh prisma-Portal ist im Mobile-Browser nicht verfügbar. 
        Bitte laden Sie die smzh prisma-App herunter.
      </p>
    </div>

    <div class="flex gap-4">
      <a target="_blank" rel="noopener" href="https://apps.apple.com/ch/app/smzh-prisma/id6743214462?l=en-GB&platform=mac">
        <img ngOptimizedImage class="h-10" [src]="'/assets/image/apple-icon.svg'" alt="App Store">
      </a>
      <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.clientportal.smzh.client_portal&hl=en">
        <img ngOptimizedImage class="h-10" [src]="'/assets/image/google-icon.svg'" alt="Google Play">
      </a>
    </div>
  </div>
</div>
